<template>
  <div 
    class="material-list"  
    :class="{'fixed-table-height': settingForm.fixedHeight}"
    :style="{'--x': popoverPositionData.x +'px', '--y': popoverPositionData.y+'px'}"
  >
    <div class="material-list-header p6">
        <div class="left">
            <span class="tabel-title">报表明细</span>
            <el-popover  placement="bottom-start" trigger="hover" :disabled="isDisabled">
                <div class="mt6" style="width: 260px;height: 120px;">
                    <el-radio-group v-model="frozenForm.type">
                        <el-radio class="block ml10 mb10" :label="FROZEN_COL_TYPE.FIRST_COLUMN">冻结第一列</el-radio>
                        <el-radio 
                            :title="isDisAllDimension?'当前维度分组数量过多,冻结将影响您查看数据':''" 
                            :disabled="isDisAllDimension"
                            class="block ml10 mb10" 
                            :label="FROZEN_COL_TYPE.ALL_DIMENSION"
                        >
                            冻结所有维度列
                        </el-radio>
                        <el-radio class="block ml10 mb10" :label="FROZEN_COL_TYPE.CUSTOM">自定义冻结列</el-radio>
                    </el-radio-group>
                    <p class="pl32 font12px text-color-gray" >
                        冻结至
                        <el-input-number
                            ref="freezeInput"
                            v-model="frozenForm.num"
                            :disabled="frozenForm.type!==FROZEN_COL_TYPE.CUSTOM"
                            size="mini"
                            controls-position="right"
                            :min="0"
                            :max="10"
                            :step="1"
                            style="width: 110px;">
                        </el-input-number>
                        列
                    </p>
                </div>
                <el-button :disabled="isDisabled" slot="reference" icon="el-icon-setting" class="mr20" size="mini">冻结列</el-button>
            </el-popover>
            
            <el-checkbox 
                :value="settingForm.showAllSummary && !!global.dimensionCheckList.length"
                :disabled="isDisabled || !global.dimensionCheckList.length"
                @input="(value)=>updateSettingForm(value, 'showAllSummary')"
            >
                显示总-汇总数据
            </el-checkbox>
            <!-- <el-checkbox 
                :value="settingForm.showDaySummary"
                @input="(value)=>updateSettingForm(value, 'showDaySummary')"
            >
                显示总-日均数据
            </el-checkbox> -->
        </div>
        <div class="right">
            <el-button 
                icon="el-icon-delete" class="mr20" size="mini" 
                :disabled="isDisabled"
                @click="()=>global.clearTabelData()"
            >
                清除表格数据
            </el-button>
            <el-checkbox 
                :value="settingForm.fixedHeight" 
                :disabled="isDisabled"
                @input="(value)=>updateFixedHeight(value)"
            >
                固定表格高度
            </el-checkbox>
            <el-button 
                v-permission="['download_report']" 
                v-matomo="{behaviorCategory: '素材查询分析', name: '列表结果区(下载报表)' }"
                icon="el-icon-download" 
                class="ml20"  
                size="mini" 
                :disabled="isDisabled"
                @click="()=>global.downloadTableData()"
            >
                下载报表
            </el-button>
        </div>
    </div>
    <div class="material-list-table" v-loading="loadingData.listLoading" element-loading-spinner="custom-loading">
        <!-- setHeadMapList -->
        <MaterialTable
            ref="MaterialTable"
            :headList="headList"
            :list="list"
            :settingForm="settingForm"
            :frozen="frozenForm"
            :flatDimensionNames="flatDimensionNames"
            :sum-data="sumData"
            :fixedTableHeight="fixedTableHeight"
        />
    </div>
    <div class="material-list-footer tac" v-if="list.length">
        <el-pagination
            @current-change="currentChange"
            :current-page="global.pageNum"
            :pager-count="5"
            :page-size="global.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="global.materialData.totalCnt">
        </el-pagination>
    </div>
    <CustomPopover 
        v-show="showPopover"
        ref="custom-popover"
        v-bind="popoverPositionData"
        @enter="handlePopoverEnter"
        @leave="()=>showPopover =false"
        @copy-content="handleCopyContent"
        @add-condition="handleAddCondition"
    />
  </div>
</template>

<script>
// import MaterialTable from './materialTable.vue'
import MaterialTable from './materialTableEl.vue'
import CustomPopover from './customPopover.vue'
import { FROZEN_COL_TYPE, DIS_ALL_DIMENSION_NUM } from '../../constant'
import { setClipboard } from '@/utils'
import { throttle } from 'lodash'
export default {
    inject: [ 'resetSelectData', 'global', 'currentChange', 'loadingData', 'addCondition' ],
    props: [ 'settingForm', 'flatDimensionList' ],
    provide() {
        return {
            setPopoverXY: (...args)=>this.handleSetPopoverXY(...args),
            colsePopover: (...args)=>this.handleColsePopover(...args)
        }
    },
    components: { MaterialTable, CustomPopover },
    data() {
        return {
            frozenForm: { 
                num: 0,
                type: FROZEN_COL_TYPE.FIRST_COLUMN
            },
            FROZEN_COL_TYPE,
            positionXY: {
                x: 0,
                y: 0
            },
            popoverPositionData: {
                x: 0,
                y: 0
            },
            popoverData: {},
            showPopover: false,
            popoverOutTime: null,
            popoverEnterTime: null,
            fixedTableHeight: 200
        }
    },
    created() {
    },
    mounted() {
        const resizeFn = throttle(()=> {
            const materialListTable = document.querySelector('.material-list-table');
            this.fixedTableHeight = materialListTable.clientHeight - 32;
            this.$refs.MaterialTable.doLayout()
        }, 200)
        window.addEventListener('resize', resizeFn);
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('resize', resizeFn)
        });
        this.$nextTick(()=> {
            resizeFn()
        })
    },
    computed: {
        list() {
            return this.global.materialData.list || []
        },
        headList() {
            return this.global.materialData.field_list || []
        },
        isDisabled() {
            return !this.list.length
        },
        flatDimensionNames() {
            return this.flatDimensionList.reduce((pre, item)=> {
                pre[item.name] = true;
                return pre;
            }, {});
        },
        isDisAllDimension() {
            const list = this.headList.filter(item=> this.flatDimensionNames[item.field]);
            return DIS_ALL_DIMENSION_NUM < list.length;
        },
        sumData() {
            return {
                total: this.global.materialData.total,
            }
        }
    },
    methods: {
        handlePopoverEnter() {
            this.showPopover =true;
            const time =  this.popoverEnterTime;
            time&&clearTimeout(time);
        },
        updateFixedHeight(value) {
            // if (value) {
            //     this.$refs['MaterialTable'].renderTask.deleteAllTask()
            // }
            this.updateSettingForm(value, 'fixedHeight')
        },
        updateSettingForm(value, key) {
            this.$emit('update:settingForm', {
                ...this.settingForm,
                [key]: value
            })
        },
        handleColsePopover(e, column, data) {
            this.popoverEnterTime = setTimeout(()=> {
            this.showPopover =false;
            const time =  this.popoverOutTime;
            time&&clearTimeout(time);
            }, 200)
        },
        // MouseEvent
        handleSetPopoverXY(e, column, data) {
            const { field, index } = this.popoverPositionData;
            if (field === column.field && index === data.index && this.showPopover) {
                return;
            };

            let p_x = e.clientX +10;
            let p_y = e.clientY;
            // 窗口边缘的判断
            if (e.clientX > window.innerWidth - 220) {
                p_x = e.clientX - 220;
            }

            if(e.clientY > window.innerHeight - 80) {
                p_y = e.clientY - 80;
            }

            const time =  this.popoverOutTime;
            time&&clearTimeout(time);
            const enterTime =  this.popoverEnterTime;
            enterTime&&clearTimeout(enterTime);
            this.positionXY = {
                x: p_x,
                y: p_y,
                field: column.field,
                index: data.index,
                data, column
            }
            this.popoverOutTime = setTimeout(()=> {
                this.showPopover = true
                this.popoverPositionData = { ...this.positionXY }
            }, 200)
        },
        // 复制内容
        async handleCopyContent() {
            const { field, data } = this.popoverPositionData
            await setClipboard(data[`_${field}`] || data[field]);
            this.$message.success('复制成功')
        },
        
        // 添加筛选
        handleAddCondition(isFirst) {
            const { field, data } = this.popoverPositionData;
            this.addCondition(isFirst, field, data[field])
        },
    },
}
</script>

<style lang="scss" scoped>
.material-list {
    min-height: 270px;
    height: 100%;
    border: 1px solid #ccc;
    &.fixed-table-height {
        display: flex;
        flex-direction: column;
    }
    &-header {
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-content: center;
        .tabel-title {
            padding-left: 4px;
            padding-right: 20px;
            font-weight: bold;
        }
    }
    &-table {
        min-height: 180px;
        flex: 1 1 0;
        overflow-y: hidden;
    }
    &-footer {
        background: #fff;
    }
}

</style>